import React, { Component } from 'react'
import { css } from 'aphrodite'
import { connect } from '@cerebral/react'
import styles from './styles'
import { ProgressBar } from './ProgressBar'
import { BasketAddButton } from './BasketAddButton'
import { Thumbnail } from './Thumbnail/'
import { signal, state, props } from 'cerebral/tags'
import isUploading from 'utils/isUploading'
import isAdmin from 'utils/isAdmin'
import { EventButton } from './EventButton'
import { Restriction } from './Restriction'
import hasPreviewProperty from 'utils/hasPreviewProperty'

class File extends Component {
  constructor(props) {
    super(props)
    this.onFileClicked = this.onFileClicked.bind(this)
    this.onDragStart = this.onDragStart.bind(this)
  }

  onDoubleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    const { onShowDetailedView, file, clickable } = this.props
    const { removed } = file
    if (
      !removed &&
      clickable &&
      !isUploading(file) &&
      hasPreviewProperty(file)
    ) {
      onShowDetailedView()
    }
  }

  onFileClicked(e) {
    e.stopPropagation()
    const { mediaClicked, path, file, clickable } = this.props
    const { removed } = file
    if (!removed && clickable && !isUploading(file)) {
      mediaClicked({ path })
    }
  }

  onDragStart(e) {
    e.preventDefault()
    e.stopPropagation()
    const { path, file, clickable, beginDragMedia } = this.props
    const { removed } = file
    if (!removed && clickable && !isUploading(file)) {
      beginDragMedia({ path })
    }
    return false
  }

  onContextMenu(e, file) {
    e.preventDefault()
    e.stopPropagation()

    if (!file.pending) {
      const { showFileContextMenu } = this.props
      showFileContextMenu({
        payload: {
          isVisible: true,
          position: { x: e.clientX, y: e.clientY },
          file
        }
      })
    }
  }

  render() {
    const { file, path, enterMedia, leaveMedia, group } = this.props
    if (!file) {
      return null
    }
    const componentStyle = css(
      styles.component,
      file.selected ? styles.selected : null,
      file.removed ? styles.removed : null
    )
    return (
      <div
        title={file.name}
        draggable={isAdmin(group)}
        onDragStart={this.onDragStart}
        className={componentStyle}
        style={{ opacity: file.pending ? 0.5 : 1.0 }}
        onDoubleClick={e => this.onDoubleClick(e)}
        onMouseDown={this.onFileClicked}
        onMouseLeave={e => {
          leaveMedia({ path })
        }}
        onContextMenu={e => this.onContextMenu(e, file)}
        onMouseEnter={e => {
          enterMedia({ path })
        }}
      >
        <Restriction restrictionType={file.restrictionType} />
        <div className={css(styles.image)}>
          <EventButton
            path={path}
            render={({ selected, uploading, path }) => {
              return uploading ? null : <BasketAddButton path={path} />
            }}
          />
          <Thumbnail path={path} />
        </div>
        <div className={css(styles.labelWrapper)}>
          {file.hasOwnProperty('percentComplete') && !file.pending ? (
            <ProgressBar percentComplete={file.percentComplete} />
          ) : null}
          <span className={css(styles.label)}>{file.name}</span>
        </div>
      </div>
    )
  }
}
File.defaultProps = { clickable: true }

export default connect(
  {
    file: state`${props`path`}`,
    mediaClicked: signal`media.mediaClicked`,
    enterMedia: signal`media.enterMedia`,
    leaveMedia: signal`media.leaveMedia`,
    onShowDetailedView: signal`media.onShowDetailedView`,
    beginDragMedia: signal`media.beginDragMedia`,
    group: state`app.user.group`,
    showFileContextMenu: signal`media.showFileContextMenu`
  },
  File
)



// WEBPACK FOOTER //
// ./src/components/Media/File/file.js